import React, { useRef, useState } from 'react';

const METE = [
  ['Lisbona','Portogallo'],['Porto','Portogallo'],['Siviglia','Spagna'],
  ['Granada','Spagna'],['San Sebastian','Spagna'],['Barcellona','Spagna'],
  ['Marrakech','Marocco'],['Essaouira','Marocco'],['Tunisi','Tunisia'],
  ['Atene','Grecia'],['Naxos','Grecia'],['Creta','Grecia'],['Rodi','Grecia'],
  ['Istanbul','Turchia'],['Cappadocia','Turchia'],['Valletta','Malta'],
  ['Dubrovnik','Croazia'],['Spalato','Croazia'],['Lubiana','Slovenia'],
  ['Vienna','Austria'],['Praga','Cechia'],['Budapest','Ungheria'],
  ['Cracovia','Polonia'],['Berlino','Germania'],['Amburgo','Germania'],
  ['Amsterdam','Paesi Bassi'],['Bruges','Belgio'],['Copenaghen','Danimarca'],
  ['Stoccolma','Svezia'],['Oslo','Norvegia'],['Isole Lofoten','Norvegia'],
  ['Reykjavik','Islanda'],['Edimburgo','Scozia'],['Dublino','Irlanda'],
  ['Parigi','Francia'],['Nizza','Francia'],['Bretagna','Francia'],
  ['Corsica','Francia'],['Lucerna','Svizzera'],['Ginevra','Svizzera'],
  ['Alghero','Sardegna'],['Ogliastra','Sardegna'],['Maddalena','Sardegna'],
  ['Taormina','Sicilia'],['Favignana','Sicilia'],['Ortigia','Sicilia'],
  ['Matera','Basilicata'],['Salento','Puglia'],['Gargano','Puglia'],
  ['Costiera Amalfitana','Campania'],['Ischia','Campania'],['Procida','Campania'],
  ['Cinque Terre','Liguria'],['Portofino','Liguria'],['Dolomiti','Trentino'],
  ['Val d\u2019Orcia','Toscana'],['Elba','Toscana'],['Assisi','Umbria'],
  ['Lago di Como','Lombardia'],['Venezia','Veneto'],
  ['Marsa Alam','Egitto'],['Zanzibar','Tanzania'],['Capo Verde','Capo Verde'],
  ['Madeira','Portogallo'],['Tenerife','Canarie'],['Lanzarote','Canarie'],
  ['New York','Stati Uniti'],['Islanda del Sud','Islanda'],
  ['Kyoto','Giappone'],['Bali','Indonesia'],['Hanoi','Vietnam'],
];

const TIPI = ['Mare e relax','Citta\u2019 d\u2019arte','Montagna','Road trip',
              'Enogastronomico','Avventura','Terme e benessere','Isole'];

const PERIODI = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno',
                 'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];

function Rullo({ valori, finale, giri, attivo }) {
  const [pos, setPos] = useState(0);
  const timer = useRef(null);

  React.useEffect(() => {
    if (!attivo) return;
    let i = 0;
    const inizio = Date.now();
    const durata = giri;
    const tick = () => {
      const passato = Date.now() - inizio;
      if (passato >= durata) {
        setPos(valori.indexOf(finale));
        clearInterval(timer.current);
        return;
      }
      i = (i + 1) % valori.length;
      setPos(i);
    };
    timer.current = setInterval(tick, 60);
    return () => clearInterval(timer.current);
  }, [attivo, finale, giri, valori]);

  return (
    <div style={{
      background:'#fff', border:'2px solid #e5e7eb', borderRadius:10,
      padding:'14px 10px', textAlign:'center', minHeight:56,
      display:'flex', alignItems:'center', justifyContent:'center',
      fontSize:15, fontWeight:600, overflow:'hidden',
    }}>
      {valori[pos]}
    </div>
  );
}

export default function VacanzaPage() {
  const [giro, setGiro]   = useState(0);
  const [esito, setEsito] = useState(null);
  const [attivo, setAttivo] = useState(false);

  const mete = METE.map(m => `${m[0]} \u00b7 ${m[1]}`);

  const gira = () => {
    const meta    = mete[Math.floor(Math.random() * mete.length)];
    const tipo    = TIPI[Math.floor(Math.random() * TIPI.length)];
    const periodo = PERIODI[Math.floor(Math.random() * PERIODI.length)];
    setEsito({ meta, tipo, periodo });
    setAttivo(true);
    setGiro(g => g + 1);
    setTimeout(() => setAttivo(false), 2600);
  };

  return (
    <div className="page-content">
      <div style={{maxWidth:640, margin:'0 auto', textAlign:'center'}}>
        <h2 style={{margin:'0 0 4px', fontSize:20}}>Dove andiamo?</h2>
        <p style={{margin:'0 0 20px', fontSize:13, color:'#6b7280'}}>
          Tre rulli, nessuna scusa.
        </p>

        <div style={{
          background:'linear-gradient(#b30000,#8a0000)', borderRadius:14,
          padding:16, boxShadow:'0 6px 20px rgba(0,0,0,.18)',
        }}>
          <div style={{display:'grid', gap:8}}>
            <Rullo key={'a'+giro} valori={mete}    finale={esito?.meta}    giri={1200} attivo={attivo} />
            <Rullo key={'b'+giro} valori={TIPI}    finale={esito?.tipo}    giri={1800} attivo={attivo} />
            <Rullo key={'c'+giro} valori={PERIODI} finale={esito?.periodo} giri={2400} attivo={attivo} />
          </div>

          <button onClick={gira} disabled={attivo}
            style={{
              marginTop:16, width:'100%', padding:'12px 0', border:'none',
              borderRadius:10, fontSize:15, fontWeight:700, cursor: attivo?'default':'pointer',
              background: attivo ? '#e5e7eb' : '#fbbf24', color:'#1f2937',
            }}>
            {attivo ? 'Girano...' : 'Gira!'}
          </button>
        </div>

        {esito && !attivo && (
          <div style={{marginTop:20, fontSize:14, color:'#374151'}}>
            <strong>{esito.meta}</strong> &mdash; {esito.tipo.toLowerCase()}, a {esito.periodo.toLowerCase()}.
          </div>
        )}
      </div>
    </div>
  );
}
